// Account Opening API
const login_account_opening = `{	
    "access_token": "eyJhbGciOiJSUzI1NiIsImtpZCI6IkYzOTM3QUZEMzBGMTE0RTAzMUM4NDdGQzdCM0Y0N0U3IiwidHlwIjoiYXQrand0In0.eyJuYmYiOjE2OTE3N",	
    "expires_in": 3600,	
    "token_type": "Bearer",	
    "scope": "example-api",	
    "publicKey": "-----BEGIN PUBLIC KEY-----\r\nEzlnuljcfLsS5adxy\r\nw/oX9nL89bOprC5mlgmn8sTEMc5ceF0HqO/iPwEVbQ/CLSYC1ucQYYVBqbNe8r4/\r\n2akAjplYZmpuB1gScQIDAQAB\r\n-----END PUBLIC KEY-----\r\n",	
    "aesKey": "UQJhoP0F6GzSQdCOmxPKyBGTJHVoi6gV",	
    "aesIV": "RuGV6tfE4ZelzX1i"	
    }`;
const list_all_resp_body = `[
    "AccountTermsConditions",
    "DayTradingRiskDisclosure",
    "ElectronicAccessTradingAgreement",
    "MarginAgreement",
    "MarginDisclosureStatement",
    "PassportVERIFICATIONGuideline",
    "PennyStockRiskDisclosure",
    "PersonalGuaranteeVC",
    "Stockslocateagreement",
    "TradingAddendumToCustomerAgreement",
    "W9Certification"
]`;
const get_options_details = `[
    {
        "optionId": 4,
        "code": "D",
        "description": "Driver License"
    },
    {
        "optionId": 4,
        "code": "L",
        "description": "Local ID"
    },
    {
        "optionId": 4,
        "code": "P",
        "description": "Passport"
    },
    {
        "optionId": 4,
        "code": "U",
        "description": "Utility Bill"
    }
]`;

const companyInitialRouteUrl = `f4e94-8fd8-5358e592-54b8-463b-93a2666eb5e`;
const beneficiaryRouteUrl = `89a625203e8-ffbb-7-435d62792d23`;
const fundingRouteUrl = `f25203e8-ffbb-4e94-4c49-bc14-`;
const signupInitialRouteUrl = `a94386d2-eae78fd8-5358e666eb5e3d170fb2aed7`;
const signupAccountRouteUrl = `a94386d2--3d170fb2aed7-4c49-bc14-3d17`;
const signupOtherRouteUrl = `a94386d2-eae7eae7-4c49-bc140fb2aed7`;
const allAccountRouteURL = `
{
    "identifierCode":"4ce8573a-bc537",
    "isBusinessEntity":true,
    "accountOpeningClientId":"User",
    "firmCode":"",
    "fullName":"John Doe",
    "email":"info@example.com",
    "status":"PENDING",
    "accountTypesAfterApproval":null,
    "backOfficeAccountNumbersAfterApproval":null,
    "reasonForCurrentStatus":"",
    "omsClientID":"",
    "omsUsername":"",
    "omsPassword":"",
    "applicationStartedDate":"01/01/0001 00:00:00",
    "applicationSubmittedDate":"01/01/0001 00:00:00",
    "applicationEndDate":"01/01/0001 00:00:00",
    "initialDataGathered":true,
    "initialDataGatheredDate":"01/01/0001 00:00:00",
    "accountFundingDataGathered":true,
    "accountFundingDataGatheredDate":"01/01/0001 00:00:00",
    "otherDataGathered":true,
    "otherDataGatheredDate":"01/01/0001 00:00:00",
    "lastUpdationDate":"01/01/0001 00:00:00",
    "accountTypes":[
       "M",
       "C"
    ],
    "lastAccountActionTakenBy":""
 }`;
const filterAccountRouteURL = `{
    "identifierCode": "a94386d2-eae770fb2aed7",
    "isBusinessEntity": false,
    "accountOpeningClientId": "User",
    "firmCode": "GDN",
    "fullName": "John Doe",
    "email": "info@example.com",
    "status": "PENDING",
    "accountTypesAfterApproval": null,
    "backOfficeAccountNumbersAfterApproval": null,
    "reasonForCurrentStatus": null,
    "omsClientID": null,
    "omsUsername": null,
    "omsPassword": null,
    "applicationStartedDate": "11/02/2022 08:51:45",
    "applicationSubmittedDate": "11/02/2022 09:05:53",
    "applicationEndDate": "01/01/0001 00:00:00",
    "initialDataGathered": true,
    "initialDataGatheredDate": "11/02/2022 08:51:45",
    "accountFundingDataGathered": true,
    "accountFundingDataGatheredDate": "11/02/2022 08:58:51",
    "otherDataGathered": true,
    "otherDataGatheredDate": "11/02/2022 09:05:53",
    "lastUpdationDate": "11/02/2022 09:05:53",
    "accountTypes": [
        "M"
    ],
    "lastAccountActionTakenBy": null
}`;

const documentlist = `[
    "AccountTermsConditions",
    "DayTradingRiskDisclosure",
    "ElectronicAccessTradingAgreement",
    "MarginAgreement",
    "MarginDisclosureStatement",
    "PassportVERIFICATIONGuideline",
    "PennyStockRiskDisclosure",
    "PersonalGuaranteeVC",
    "Stockslocateagreement",
    "TradingAddendumToCustomerAgreement",
    "W9Certification"
]`;

const singleDocLink = `https://example.com/AccountOpenngDisclosureDocuments`;
const apiOptionListAll = `[
    {
        "optionId": 1,
        "code": "1",
        "description": "InvestmentRiskTolerance"
    },
    {
        "optionId": 20,
        "code": "20",
        "description": "YearsOfExperience"
    },
    {
        "optionId": 19,
        "code": "19",
        "description": "AssetClass"
    },
    {
        "optionId": 18,
        "code": "18",
        "description": "TaxWithholdingCertifications"
    },
    {
        "optionId": 17,
        "code": "17",
        "description": "TimeToAchieveFinancialGoal"
    },
    {
        "optionId": 16,
        "code": "16",
        "description": "LiquidityNeeds"
    },
    {
        "optionId": 15,
        "code": "15",
        "description": "SpecialExpenses"
    },
    {
        "optionId": 14,
        "code": "14",
        "description": "AnnualExpenses"
    },
    {
        "optionId": 13,
        "code": "13",
        "description": "InvestmentObjectives"
    },
    {
        "optionId": 12,
        "code": "12",
        "description": "TaxRate"
    },
    {
        "optionId": 11,
        "code": "11",
        "description": "LiquidNetWorth"
    },
    {
        "optionId": 10,
        "code": "10",
        "description": "NetWorthExcludingResidence"
    },
    {
        "optionId": 9,
        "code": "9",
        "description": "AnnualIncome"
    },
    {
        "optionId": 8,
        "code": "8",
        "description": "IncomeSource"
    },
    {
        "optionId": 7,
        "code": "7",
        "description": "EmploymentStatus"
    },
    {
        "optionId": 6,
        "code": "6",
        "description": "TaxStatus"
    },
    {
        "optionId": 5,
        "code": "5",
        "description": "IsW8OrW9Forms"
    },
    {
        "optionId": 4,
        "code": "4",
        "description": "ValidGovtIDType"
    },
    {
        "optionId": 3,
        "code": "3",
        "description": "MaritalStatus"
    },
    {
        "optionId": 2,
        "code": "2",
        "description": "IdentificationProofType"
    },
    {
        "optionId": 21,
        "code": "21",
        "description": "Knowledge"
    },
    {
        "optionId": 22,
        "code": "22",
        "description": "JointIsW8OrW9Forms"
    },
    {
        "optionId": 23,
        "code": "23",
        "description": "GroupCode"
    }
]`;

const apiOptionDetails = `[
    {
        "optionId": 1,
        "code": "1",
        "description": "Conservative"
    },
    {
        "optionId": 1,
        "code": "2",
        "description": "Moderately Conservative"
    },
    {
        "optionId": 1,
        "code": "3",
        "description": "Moderate"
    },
    {
        "optionId": 1,
        "code": "4",
        "description": "Moderately Aggressive"
    },
    {
        "optionId": 1,
        "code": "5",
        "description": "Significant Risk"
    }
]`;

// Funding API
const login_funding = `{
    "roles": [
       "Admin"
    ],
   "permissions": {
       "CreateAccount": true,
       "DeleteAccount": true,
       "UpdateAccount": true,
       "GetAccounts": true,
       "MakeRequestScreen": true,
       "ViewAccounts": true,
       "SeeLogs": true,
       "MakeRequest": true,
       "CancelRequest": true,
       "Register": true,
       "FlowCondition": true,
       "ConfigurationSetup": true,
       "CreateAnnouncement": true,
       "UpdateAnnouncement": true,
       "ViewAnnouncement": true
    },
    "token": "eyJhbGciOwDprAniDtcDWnb1R4",
   "expiration": "2023-09-13T07:59:56Z",
   "duoHost": "api-0fe98b2b.duosecurity.com",
   "duoSigRequest": "TX|amF3YWE5OTY=|49db7ce:APP|amF3YTUyOTY=|d5df7c461436",
   "userName": "JohnDoe"
 }`;

const fundRequest = `{ 
    "statusCode": 201,
    "status": true,
    "message": "Fund request created successfully",
    "data": null,
    "fundRequestId": 69,
    "bankingInstructionSetupId": 20
}`;

const fundRequestValidation = `{
    "errors": {
        "Amount": [
            "Should be in proper format. Zero or 0.0 will not be acceptable and maximum range is 15 digits with 6 digits of fractional part"
        ],
        "RequestTypeId": [
            "The field RequestTypeId must be between 1 and 2.",
            "RequestType must be numeric and either 1 or 2",
            "Invalid RequestTypeId, only 1 will be acceptable in RequestTypeId for ACH"
        ],
        "TransactionTypeId": [
            "The field TransactionTypeId must be between 1 and 2.",
            "TransactionTypeId must be numeric and either 1 or 2"
        ],
        "BackOfficeAccountNumber": [
            "BackOfficeAccountNumber is not valid must be like this 1XXX-XXX-000001-X OR 1XXX-2XXX-000001-XX"
        ]
    },
    "type": "https://example.com",  
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-62eafad602319c-00"
}`;

const getAccessToExternalAPICreate = `{
    "statusCode": 201,
    "status": true,
    "message": "Wire Request Created and Auto Approved",
    "data": null,
    "fundRequestId": 197,
    "bankingInstructionSetupId": 75
}`;

const getAccessToExternalAPIAdd = `{
    "statusCode": 201,
    "status": true,
    "message": "Fund Request Created and Auto Approved",
    "data": null,
    "fundRequestId": 261,
    "bankingInstructionSetupId": 75
}`;

const getAccessToExternalAPI = `{
    "statusCode": 201,
    "status": true,
    "message": "Fund request created successfully",
    "data": null,
    "fundRequestId": 504,
    "bankingInstructionSetupId": 213
}`;

const getAccessToExternalAPIValidation = `	{	
    "errors": {	
        "ABA": [	
            "SwiftABA must be alphanumeric"	
        ],	
        "City": [	
            "Can't use special characters in City"	
        ],	
        "Amount": [	
            "Should be in proper format. Zero or 0.0 will not be acceptable and maximum range is 15 digits with 6 digits of fractional part"	
        ],	
        "Account": [	
            "Account must be numeric"	
        ],	
        "StateId": [	
            "State does not exist against the given id"	
        ],	
        "FirstName": [	
            "Can't use digit or special characters except for Dot and Apostrophe in First Name"	
        ],	
        "RequestTypeId": [	
            "RequestType must be numeric and either 1 or 2",	
            "Invalid RequestTypeId, only 1 will be acceptable in RequestTypeId for ACH"	
        ],	
        "BackOfficeAccountNumber": [	
            "BackOfficeAccountNumber is not valid must be like this 1XXX-XXX-000001-X OR 1XXX-2XXX-000001-XX, X is indicating alphabets"	
        ]	
    },	
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",  	
    "title": "One or more validation errors occurred.",	
    "status": 400,	
    "traceId": "00-ac6d19135db43cb45a06c4cfb3afac33-e34459a429999abe-00"	
}`;

const getFundRequestDetails = `{
    "statusCode": 200,
    "status": true,
    "message": "Successful. Data exists against the given id = 5",
    "data": {
        "Id": 5,
        "FirstName": "John",
        "LastName": "Doe",
        "Amount": 9999999999999.99,
        "ReversalFee": 0.0,
        "AccountInfo": "dfdf",
        "AccountTypeId": 1,
        "Account": "645645",
        "BackOfficeAccountNumber": "6534343423544565-5",
        "AccountName": "Example Bank",
        "Address": "14th Street North Bay",
        "ABA": "654656",
        "RoutingCode": "654656",
        "Pending": false,
        "Cancelled": false,
        "Approved": true,
        "Rejected": false,
        "ApprovalStatus": "Approved",
        "Created": "2023-02-14T07:49:24.797591",
        "LastUpdated": "2023-05-08T10:49:47.100253",
        "RejectReason": "",
        "RequestTypeId": 1,
        "TransactionTypeId": 2,
        "ACHProcessorStatus": null,
        "ACHProcessorReason": null,
        "ACHProcessorActualResponse": null,
        "ACHProcessorTransferID": null,
        "Failed": false,
        "FailedReason": null,
        "BankDetailsMismatch": false
    },
    "id": 5
}`;

const getAllbankingDetailsInst = `	{	
    "statusCode": 200,	
    "status": true,	
    "message": "Banking Instructions exist and fetched",	
    "data": {	
        "Banking Instruction Setups": [	
            {	
                "Id": 20,	
                "FirstName": "John",	
                "LastName": "Doe",	
                "Account": "123456",	
                "BackOfficeAccountNumber": "1Gdfsf5-dfgf-004-M",	
                "AccountName": "Example BANK",	
                "Address": "14th Street North ",	
                "Apt": "H-No 123",	
                "Country": "US",	
                "State": "NY",	
                "City": "Bayharbour",	
                "ZipCode": "10253",	
                "ABA": "AB090078601",	
                "AccountInfo": null,	
                "AccountTypeId": 1,	
                "IsDefault": true,	
                "Created": "2023-08-11T07:56:40.43804"	
            }	
        ]	
    },	
    "id": null	
}`;

const getAllAuditTrails = `{
    "statusCode": 200,
    "status": true,
    "message": "Successful. Data exists",
    "data": {
      "“CurrentPage“": 1,
      "“PageSize\"\"": 100,
      "NextPage": 2,
      "Data": [
        {
          "Id": 1417,
          "RequestId": 368,
          "FirstName": "Jhon",
          "LastName": "Doe",
          "Amount": 49999,
          "Account": "1111",
          "BackOfficeAccountNumber": "1GDN-GDN-088750-C",
          "AccountInfo": null,
          "AccountTypeId": 2,
          "AccountName": "Plaid Silver Standard 0.1% Interest Saving",
          "Address": "Scottish Highlands",
          "Apt": null,
          "Country": "233",
          "State": "3077",
          "City": "Hazlet",
          "ZipCode": "07730",
          "ABA": "011401533",
          "RoutingCode": null,
          "Status": "Execution Successfull",
          "CreatedBy": "GuardianUser",
          "Action": "Execution Successfull",
          "ActionBy": "Internal User",
          "Created": "2023-06-09T14:48:50.862327",
          "LastUpdated": "2023-06-12T14:2:08.126816",
          "Reason": "Transaction Executed Scucessfully",
          "RequestTypeId": 1,
          "TransactionTypeId": 2,
          "FirmName": "Guardian",
          "ACHProcessorStatus": "Transaction Executed Scucessfully",
          "Requestee": "Professor Dumbeldore"
        }
      ]
    }
  
  }`;

const getAllAuditTrailsByDate = `{
    "statusCode": 200,
    "status": true,
    "message": "Successful. Data exists ",
    "data": {
      "CurrentPage": 1,
      "PageSize": 5,
      "PreviousPage": 0,
      "NextPage": 2,
      "Data": [
        {
          "Id": 1963,
          "RequestId": 503,
          "FirstName": "John",
          "LastName": "Doe",
          "Amount": 50000.0,
          "Account": "0000",
          "BackOfficeAccountNumber": "1GDN-GDsxsds-00091-M",
          "AccountInfo": null,
          "AccountTypeId": 1,
          "AccountName": "Example BANK",
          "Address": "14th Street North Bay",
          "Apt": "H-No 789",
          "Country": "233",
          "State": "3077",
          "City": "Bayharbour",
          "ZipCode": "10253",
          "ABA": "090078601",
          "RoutingCode": null,
          "Status": "Pending",
          "CreatedBy": "Admin",
          "Action": "Approved",
          "ActionBy": "Internal User",
          "Created": "2023-07-26T12:37:36.883343",
          "LastUpdated": "2023-07-27T08:33:31.389642",
          "Reason": "",
          "RequestTypeId": 1,
          "TransactionTypeId": 1,
          "FirmName": "Internal",
          "ACHProcessorStatus": null,
          "Requestee": "John Doe"
        }
      ]
    }
  }
`;

const getAllFundRequests = `{
    "statusCode": 200,
    "status": true,
    "message": "Successful fetched all the fund requests",
    "data": {
      “CurrentPage“: 1,
      “PageSize"": 1000,
      "NextPage": 2,
      "Data": [
        {
          "Id": 5,
          "FirstName": "John",
          "LastName": "Doe",
          "Amount": 3333333333,
          "ReversalFee": 0.0,
          "AccountInfo": "john_doe",
          "AccountTypeId": 1,
          "Account": "645645",
          "BackOfficeAccountNumber": "6565-464-645645-5",
          "AccountName": "Example BANK ",
          "Address": "14th Street North Bay",
          "Apt": "AB-47",
          "Country": "",
          "State": "",
          "City": "",
          "ZipCode": "",
          "ABA": "654656",
          "RoutingCode": "654656",
          "Pending": false,
          "Cancelled": false,
          "Approved": true,
          "Rejected": false,
          "ApprovalStatus": "Approved",
          "Created": "2023-02-14T07:49:24.797591",
          "LastUpdated": "2023-05-08T10:49:47.100253",
          "RejectReason": "",
          "RequestTypeId": 1,
          "TransactionTypeId": 2,
          "ACHProcessorStatus": null,
          "ACHProcessorReason": null,
          "ACHProcessorActualResponse": null,
          "ACHProcessorTransferID": null,
          "Failed": false,
          "FailedReason": null,
          "BankDetailsMismatch": false
        }
      ]
    }
  
  }`;

const getAllBankInstruction = `{
    "statusCode": 200,
    "status": true,
    "message": "Banking Instructions exist and fetched",
    "data": {
        "Banking Instruction Setups": [
            {
                "Id": 66,
                "FirstName": "Ram",
                "LastName": "Paul",
                "Account": "0000",
                "BackOfficeAccountNumber": "1Gssd-sdsd-0777-E",
                "AccountName": "Example BANK",
                "Address": "614 Courthouse Circle",
                "ABA": "52525252",
                "AccountInfo": "Info of Ram account and this is the defalt account aganist BO 1GDasdsad-0007-K and UserId",
                "AccountTypeId": 1,
                "IsDefault": true,
                "Created": "2022-10-13T12:13:06.798791"
            },
            {
                "Id": 70,
                "FirstName": "Ram",
                "LastName": "Paul",
                "Account": "0000",
                "BackOfficeAccountNumber": "1GDasadasd-asdasdas0777-E",
                "AccountName": "Example bank",
                "Address": "14th Street North Bay",
                "ABA": "52525252",
                "AccountInfo": "Info of Ram account and this is the defalt account aganist BO 1GDasda-sd007-K and UserId",
                "AccountTypeId": 1,
                "IsDefault": true,
                "Created": "2022-10-18T13:33:40.267952"
            }
        ]
    },
    "id": null
}`;
const getallsingle = `{
        "statusCode": 200,
        "status": true,
        "message": "Successful fetched all the fund requests",
        "data": {
          “CurrentPage“: 1,
          “PageSize"": 1000,
          "NextPage": 2,
          "Data": [
            {
              "Id": 5,
              "FirstName": "John",
              "LastName": "Doe",
              "Amount": 9999999999999.99,
              "ReversalFee": 0.0,
              "AccountInfo": "dfdf",
              "AccountTypeId": 1,
              "Account": "645645",
              "BackOfficeAccountNumber": "6565-464-645645-5",
              "AccountName": "Example BANK",
              "Address": "14th Street North Bay",
              "Apt": "AB-47",
              "Country": "",
              "State": "",
              "City": "",
              "ZipCode": "",
              "ABA": "654656",
              "RoutingCode": "654656",
              "Pending": false,
              "Cancelled": false,
              "Approved": true,
              "Rejected": false,
              "ApprovalStatus": "Approved",
              "Created": "2023-02-14T07:49:24.797591",
              "LastUpdated": "2023-05-08T10:49:47.100253",
              "RejectReason": "",
              "RequestTypeId": 1,
              "TransactionTypeId": 2,
              "ACHProcessorStatus": null,
              "ACHProcessorReason": null,
              "ACHProcessorActualResponse": null,
              "ACHProcessorTransferID": null,
              "Failed": false,
              "FailedReason": null,
              "BankDetailsMismatch": false
            }
          ]
        }
      
      }`;

const getSpecificfundRequests = `{
    "statusCode": 200,
    "status": true,
    "message": "Successful fetched all the fund requests",
    "data": {
      “CurrentPage“: 1,
      “PageSize"": 50,
      "NextPage": 2,
      "Data": [
        {
          "Id": 5,
          "FirstName": "john",
          "LastName": "Doe",
          "Amount": 50000,
          "ReversalFee": 0.0,
          "AccountInfo": "dfdf",
          "AccountTypeId": 1,
          "Account": "645645",
          "BackOfficeAccountNumber": "6565-464-645645-5",
          "AccountName": "Example bank",
          "Address": "14th Street North Bay",
          "Apt": "AB-47",
          "Country": "",
          "State": "",
          "City": "",
          "ZipCode": "",
          "ABA": "654656",
          "RoutingCode": "654656",
          "Pending": false,
          "Cancelled": false,
          "Approved": true,
          "Rejected": false,
          "ApprovalStatus": "Approved",
          "Created": "2023-02-14T07:49:24.797591",
          "LastUpdated": "2023-05-08T10:49:47.100253",
          "RejectReason": "",
          "RequestTypeId": 1,
          "TransactionTypeId": 2,
          "ACHProcessorStatus": null,
          "ACHProcessorReason": null,
          "ACHProcessorActualResponse": null,
          "ACHProcessorTransferID": null,
          "Failed": false,
          "FailedReason": null,
          "BankDetailsMismatch": false
        }
      ]
    }
  
  }`;
// Trading API
const login_trading_api = `{
    "access_token": "eyJhbGciOiJSUzI1I6MTY2ODE2NTg5MiwiaXNzIjoiaHRo268PzDP1biDmV8SMyWDPQ0cDovL2xvY2FsaG9zdDo4iOiIxMCIsInN1YiUiOjE2NjgxNjUyOTIsImlkcCI6ImxvY2K84vnRrMjBlv8EAtYeaUddNZ4",
    "expires_in": 600,
    "token_type": "Bearer",
    "refresh_token": "C3A7B6193250E233734",
    "scope": "offline_access"
}`;

const static_data_accounts = `{
    "success": true,
    "message": "",
    "data": {
        "eventType": -1,
        "eventData": [
            {
                "isBoxVsShort": false,
                "cmtas": [],
                "name": "account1",
                "value": "account1",
                "booth": "booth_one"
            }
        ]
    }
}`;

const renew_access_token = `{
    {
        "access_token": "IjAGceyJhbxv_URIJnFHD7ngMPuEe5-wROUZPQ",
        "expires_in": 600,
        "token_type": "Bearer",
        "refresh_token": "A748642FDD236CA4FCEE4B5DA10B13874860108F0F",
        "scope": "marketdata-api oms-api offline_access"
    }
}`;
const static_data_account = `{
    "eventType": -1,
    "eventData": [
        {
            "name": "John Doe",
            "value": "jhondoe",
            "booth": "LSL"
        }
    ]
}`;

const static_data_side = `{
    "eventType": -1,
    "eventData": [
        {
            "name": "BUY",
            "value": "1",
            "booth": null
        },
        {
            "name": "SELL",
            "value": "2",
            "booth": null
        },
        {
            "name": "SS",
            "value": "5",
            "booth": null
        }
    ]
}`;

const static_data_tif = `{
    "eventType": -1,
    "eventData": [
        {
            "name": "Day",
            "value": "0",
            "booth": null
        },
        {
            "name": "GTC",
            "value": "1",
            "booth": null
        },
        {
            "name": "OPG",
            "value": "2",
            "booth": null
        },
        {
            "name": "IOC",
            "value": "3",
            "booth": null
        },
        {
            "name": "FOK",
            "value": "4",
            "booth": null
        }
    ]
}`;

const static_data_order_type = `{
        "eventType": -1,
        "eventData": [
            {
                "name": "MKT",
                "value": "1",
                "booth": null
            },
            {
                "name": "LMT",
                "value": "2",
                "booth": null
            },
            {
                "name": "STOP",
                "value": "3",
                "booth": null
            },
            {
                "name": "STOP LMT",
                "value": "4",
                "booth": null
            }
        ]
    }`;

const static_data_locate_tif = `{
    "eventType": -1,
    "eventData": [
        {
            "name": "IOC",
            "value": "3",
            "booth": null
        },
        {
            "name": "FOK",
            "value": "4",
            "booth": null
        }
    ]
}`;

const static_data_destination = `{
    "eventType": -1,
    "eventData": [
        {
            "name": "NYSE",
            "value": "NYSE",
            "booth": null
        },
        {
            "name": "ARCA",
            "value": "ARCA",
            "booth": null
        }
    ]
}`;

const orders_orders = `{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-5fce3562ecadbcc3f26e-00",
    "errors": {
        "Account": [
            "Invalid account selected"
        ]
    }
}`;

const orders_update = `{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-01be0fbd-170bdd212e0d4d48-00",
    "errors": {
        "OrderQty": [
            "Invalid quantity"
        ]
    }
}
`;
const orders_cancel = `
{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-01be0fb22f-170bdd212e0d4d48-00",
    "errors": {
        "PropertyName": [
            "Validation Message for the property"
        ]
    }
}`;

const option_order_post = `{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-0d5ecd5-6007c663e0263586-00",
    "errors": {
        "Account": [
            "Invalid account selected"
        ]
    }
}`;

const option_order_update = `{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-760f72a527c9b8d5fc5e2-00",
    "errors": {
        "OrdType": [
            "Invalid orderType"
        ]
    }
}`;

const option_order_cancel = `{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-0d5eca05-6007c663e0263586-00",
    "errors": {
        "Account": [
            "Invalid account selected"
        ]
    }
}`;

const locate_request = `{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-4f9bf2d297ff7362bd100d4-00",
    "errors": {
        "OrderQty": [
            "Invalid quantity"
        ]
    }
}`;

const locate_acquire = `{
    "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
    "title": "One or more validation errors occurred.",
    "status": 400,
    "traceId": "00-de6ad3c62ade89add37149c-00",
    "errors": {
        "TimeInForce": [
            "Invalid time in force selected"
        ]
    }
}`;

// Journal API

const journal_success_response = `{
  "roles": [
        "role"
    ],
    "permissions": {
        "permission": true
    },
    "token": "Token",
    "expiration": "2025-05-15T06:52:05Z",
    "userName": "username"
}`;

const post_journal_entry_success_response = `{
  "isSuccess": true,
  "errorMessage": null
}`;

const post_journal_entry_batch_success_response = `{
  "isSuccess": true,
  "errorMessage": null
}`;

export default {
  account_opening: {
    login_account_opening,
    list_all_resp_body,
    get_options_details,
    companyInitialRouteUrl,
    beneficiaryRouteUrl,
    fundingRouteUrl,
    signupInitialRouteUrl,
    signupAccountRouteUrl,
    signupOtherRouteUrl,
    allAccountRouteURL,
    filterAccountRouteURL,
    documentlist,
    singleDocLink,
    apiOptionListAll,
    apiOptionDetails,
  },
  funding: {
    login_funding,
    fundRequest,
    fundRequestValidation,
    getAccessToExternalAPICreate,
    getAccessToExternalAPIAdd,
    getAccessToExternalAPI,
    getAccessToExternalAPIValidation,
    getFundRequestDetails,
    getAllbankingDetailsInst,
    getAllAuditTrailsByDate,
    getAllAuditTrails,
    getAllFundRequests,
    getAllBankInstruction,
    getallsingle,
    getSpecificfundRequests,
  },

  trading: {
    login_trading_api,
    static_data_accounts,
    renew_access_token,
    static_data_account,
    static_data_side,
    static_data_tif,
    static_data_order_type,
    static_data_locate_tif,
    static_data_destination,
    orders_orders,
    orders_update,
    orders_cancel,
    option_order_post,
    option_order_update,
    option_order_cancel,
    locate_request,
    locate_acquire,
  },

  journal: {
    journal_success_response,
    post_journal_entry_success_response,
    post_journal_entry_batch_success_response,
  },
};
